import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../shared/models/response.model';
import { FinParcours } from '../models/fin-parcours.model';

@Injectable({
  providedIn: 'root',
})
export class FinParcoursService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/fins-parcours`;

  trouverTous = (idReferentiel: string) =>
    this.#http.get<Response<FinParcours>>(this.BASE_URL, { params: { idReferentiel } });

  supprimer(idFinParcours: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idFinParcours);
  }
}
